//Modules
export { default as AppModule } from "./app/store/";
export { default as AppointmentManagement } from "./appointment-management/";
export { default as CommonModule } from "./common/store/";
export { default as DashboardModule } from "./dashboard/";
export { default as OperationCalendarEventModule } from "./operation-calendar-event/";
export { default as OperationFormManagementModule } from "./operation-form-management/";
export { default as OperationMessageModule } from "./operation-message/";
export { default as OperationSchoolManagementModule } from "./operation-school-management/";
export { default as ParentInventory } from "./parent-inventory/";
export { default as ReferralAtModule } from "./referral-at/";
export { default as ReferralModule } from "./referral/";
export { default as StudentProvisionalRemedyAnswerModule } from "./student-answer-rp/";
export { default as StudentCompuHistoryModule } from "./student-compu-history/";
export { default as StudentEvaluationHistoryModule } from "./student-evaluation-history/";
export { default as StudentEvalutionRequestManagmentModule } from "./student-evaluation-request-managment/store/";
export { default as StudentFollowUpGraduate } from "./student-follow-up-graduate/store/";
export { default as StudentModule } from "./student/";
export { default as UbicationTechAssistanceMngmtModule } from "./ubication-tech-assistance-mngmt";
export { default as UserModule } from "./user/";
export { default as WelcomePortalModule } from "./welcome-portal/";
export { default as ProgramServiceModule } from "@/components/pei/programservice/store/";
export { default as AdmendmentModule } from "./admendment";

//Names
import { name as appModuleName } from "./app/store/";
import { name as commonModuleName } from "./common/store";
import { name as dashboardModuleName } from "./dashboard";
import { name as operationCalendarEventModuleName } from "./operation-calendar-event";
import { name as operationFormManagementModuleName } from "./operation-form-management";
import { name as operationMessageModuleName } from "./operation-message";
import { name as operationSchoolManagementModuleName } from "./operation-school-management";
import { name as referralModuleName } from "./referral";
import { name as studentProvisionalRemedyAnswerModuleName } from "./student-answer-rp";
import { name as studentCompuHistoryModuleName } from "./student-compu-history";
import { name as StudentEvalutionRequestManagmentModuleName } from "./student-evaluation-request-managment/store";
import { name as StudentFollowUpGraduateModuleName } from "./student-follow-up-graduate/store";
import { name as studentModuleName } from "./student/";
import { name as userModuleName } from "./user/";
import { name as welcomePortalModuleName } from "./welcome-portal/";
import { name as programServiceModuleName } from "@/components/pei/programservice/store";
import { name as AdmendmentModuleName } from "./admendment";

export const modulesName = {
  appModuleName: appModuleName,
  commonModuleName: commonModuleName,
  referralModuleName: referralModuleName,
  studentProvisionalRemedyAnswerModuleName,
  welcomePortalModuleName,
  studentCompuHistoryModuleName,
  dashboardModuleName,
  StudentEvalutionRequestManagmentModuleName,
  StudentFollowUpGraduateModuleName,
  operationMessageModuleName,
  operationCalendarEventModuleName,
  operationSchoolManagementModuleName,
  operationFormManagementModuleName,
  userModuleName,
  studentModuleName,
  programServiceModuleName,
  AdmendmentModuleName
};
